import { useState, useRef, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Button, Box, Typography, IconButton } from '@mui/material';
import VacationService from '../../../services/vacation';
import { Toast } from '../../../utils/alerts';
import CloseIcon from '@mui/icons-material/Close';

export default function VerificationModal({ open, correoVerificacion, onClose, setOpenModalLoader, id_papeleta, EnviarToken, QuePapeletasCargar }) {
    const [codigo, setCodigo] = useState(['', '', '', '', '', '']);
    const [segundos, setSegundos] = useState(60);
    const inputsRef = useRef([]);

    useEffect(() => {
        if (open) {
            setCodigo(['', '', '', '', '', '']);
            setSegundos(60);
        }
    }, [open]);

    useEffect(() => {
        if (segundos > 0) {
            const timer = setTimeout(() => setSegundos(segundos - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [segundos]);

    const handlePaste = (e, index) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text').toUpperCase();
        const newCodigo = [...codigo];
        for (let i = 0; i < paste.length && index + i < 6; i++) {
            newCodigo[index + i] = paste[i];
        }
        setCodigo(newCodigo);
        const nextIndex = Math.min(index + paste.length, 5);
        inputsRef.current[nextIndex]?.focus();
    };

    const handleChange = (index, value) => {
        const newCodigo = [...codigo];
        newCodigo[index] = value.toUpperCase();
        setCodigo(newCodigo);
        if (value && index < 5) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !codigo[index] && index > 0) {
            inputsRef.current[index - 1]?.focus();
        }
    };

    const cerrarDialog = (e, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
        }
        onClose();
    }

    const enviarCodigo = async () => {
        if (codigo.join('').length === 6) {
            try {
                setOpenModalLoader(true);
                const result = await VacationService.approveToken({ token: codigo.join('') }, id_papeleta.toString());
                QuePapeletasCargar();
                onClose();
                Toast.fire({
                    icon: 'success',
                    title: result.data.message
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                });
                console.error(error);
            } finally {
                setOpenModalLoader(false);
            }
        } else {
            Toast.fire({
                icon: 'error',
                title: '¡Ingresa todos los digitos!'
            });
        }
    };

    return (
        <Dialog open={open} onClose={cerrarDialog}>
            <DialogTitle sx={{ m: 0, p: 2 }}>
                Validación de la aprobación
                <IconButton
                    aria-label="close"
                    onClick={cerrarDialog}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Typography>
                    Se envió el código al correo: <b>{correoVerificacion}</b>
                </Typography>

                <Box display="flex" justifyContent="center" gap={{ xs: 0, sm: 1.5, md: 2 }} mt={2}>
                    {codigo.map((val, i) => (
                        <TextField
                            key={i}
                            inputRef={el => inputsRef.current[i] = el}
                            value={val}
                            onChange={(e) => handleChange(i, e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, i)}
                            onPaste={(e) => handlePaste(e, i)}
                            inputProps={{ maxLength: 1, style: { textAlign: 'center', fontSize: '1.5rem' } }}
                            sx={{ width: 56 }}
                            autoFocus={i === 0}
                        />
                    ))}
                </Box>

                <Box mt={3} textAlign="center">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={enviarCodigo}
                        disabled={codigo.some(val => val === '')}
                        fullWidth
                    >
                        Enviar
                    </Button>
                </Box>

                <Box mt={2} textAlign="center">
                    {segundos > 0 ? (
                        <Typography variant="body2" color="textSecondary">
                            Puedes reenviar el código en {segundos} segundos
                        </Typography>
                    ) : (
                        <Button
                            variant="text"
                            onClick={() => {
                                setSegundos(60);
                                EnviarToken();
                            }}
                        >
                            Reenviar código
                        </Button>
                    )}
                </Box>
            </DialogContent>
        </Dialog>

    );
}